import { useMemo } from 'react';
import { SkeletonPlaceHolder } from '@pu/mpp-ui/components/skeleton';
import { useAppSelector } from 'core/store';
import {
  selectAllModulesNavigationByPlatform,
  selectIsModuleNavigationLoading,
} from 'core/store/module-navigation/selectors';
import { transformModuleNavigationToNavItems } from 'shared/utils/routes/menu.utils';
import { SideNavFooter, SideNavHeader, SideNavList, SidenavListSkeleton } from './components';

import './side-nav.scss';

interface ISideNavProps {
  currentPath: string;
}

export const SideNav = ({ currentPath }: ISideNavProps) => {
  const isMenuLoading = useAppSelector(selectIsModuleNavigationLoading);
  const moduleRoutes = useAppSelector(selectAllModulesNavigationByPlatform);

  const navItems = useMemo(() => moduleRoutes.map(transformModuleNavigationToNavItems), [moduleRoutes]);

  return (
    <nav className="sidenav">
      <SideNavHeader />
      <SkeletonPlaceHolder skeleton={<SidenavListSkeleton />} loading={isMenuLoading}>
        <SideNavList items={navItems} currentPath={currentPath} />
      </SkeletonPlaceHolder>
      <SideNavFooter />
    </nav>
  );
};
